import type { ItemInstanceConfig } from '@/entities';

// Configuration for items placed on the ground in the game world
// These items can be picked up by the player
export const groundItemsConfig: ItemInstanceConfig[] = [
  // Example items - customize positions based on your game world
  // {
  //   x: 1500,
  //   y: 1300,
  //   itemId: 'teddy_bear',
  //   quantity: 1,
  //   size: 30,
  //   interactionRadius: 60,
  //   colliderVisible: true,
  //   dialog : "Yan mendapatkan boneka beruang"
  // },
  // {
  //   x: 2200,
  //   y: 1400,
  //   itemId: 'key_rusty',
  //   quantity: 1,
  //   size: 25,
  //   interactionRadius: 200,
  //   colliderVisible: false,
  // },
  // {
  //   x: 2700,
  //   y: 1200,
  //   itemId: 'flower_red',
  //   quantity: 1,
  //   size: 28,
  //   interactionRadius: 55,
  //   colliderVisible: false,
  // },
];
